import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Spinner from '@atlaskit/spinner'

import { fetchExampleMapAsync, clearExampleMap, openExportDialogue, saveExampleMap, closeEditor, openFeedbackDialogue } from '../../actioncreators/actioncreators'

import Questions from './questions'
import Rules from './rules'
import HelpButton from './helpButton'
import queryString from 'query-string'
import { hosts } from '../../hostAdapters/hosts'
import swal from 'sweetalert'
import ExportDialogue from './exportDialogue'
import FeedbackDialogue from './feedbackDialogue'
import Notes from './Notes'

const numberOfRulesToPromptSplit = 6

const Header = styled.div`
  display: flex;
  min-height: 48px;
  max-height: 48px;
  z-index: 10000;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  padding: 6px 10px;
  border-top: solid #ccc 1px;
  border-bottom: solid #ccc 1px;
  box-shadow: 0px 1px 3px #ccc;
`

const InfoMessage = styled.div`
  padding: 6px 7px;
  border-radius: 4px;
  background-color: #d8dbe669;
  flex-grow: 1;
  text-align: center;
  margin-right: 10px;
`

const Body = styled.div`
  margin-top: 65px;
`

const SplashScreen = styled.div`
  max-height: calc(100% - 100px);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
  box-shadow: 0px 1px 2px 0px rgba(9, 30, 66, 0.25);
  padding: 20px;
  z-index: 500;
  font-size: 1.5em;
  background: #eaeaea;
`

const Summary = styled.div`
  background-color: #ffe66a;
  color: #414048;
  border-width: 0 0 0 10px;
  padding-left: 10px;
  padding-top: 7px;
  font-family: sans-serif;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 35%;
  padding-right: 10px;
  flex-grow: 2;
  margin-right: 10px;
  border-radius: 4px;
`

const { Component } = React

function getInfoText (numberOfRules, numberOfExamples) {
  let info = null
  if (numberOfRules > numberOfRulesToPromptSplit) {
    info = 'You have ' + numberOfRules + ' rules. Consider splitting the story if it\'s getting complex.'
  } else if (numberOfRules > 1) {
    let ratio = numberOfRules / numberOfExamples
    if (ratio > 1.5) {
      info = 'Consider adding more examples.'
    } else if (ratio < 0.3) {
      info = 'You have lots of examples. Consider teasing out more rules.'
    }
  }
  return info
}

class Editor extends Component {
  componentWillMount () {
    const parsed = queryString.parse(window.location.search)
    if (this.props.host !== hosts.STANDALONE && parsed.lic !== 'active' && window.location.host !== 'localhost:3000') {
      return
    }
    this.props.fetchExampleMap()
  }

  render () {
    return <div style={{ display: 'flex' }}>
      <div style={{ width: '100%' }}>
        <Header>
          <Summary title={this.props.summary}><b>{this.props.issueKey}</b> {this.props.summary}</Summary>
          <InfoMessage title='Example map information'>{this.props.infoMessage}</InfoMessage>
          <div style={{ flexGrow: 0 }}>
            <button onClick={this.props.openFeedbackDialogue} className='btn btn-default' title='Feedback' style={{ marginRight: 5 }}><i className='fas fa-comments' /></button>
            <button onClick={this.props.openExportDialogue} className='btn btn-default' title='Export' style={{ marginRight: 5 }}><i className='fas fa-file-export' /></button>
            <button onClick={this.props.clear} className='btn btn-default' title='Clear Example Map' style={{ marginRight: 5 }}><i className='fas fa-trash' /></button>
            <span style={{ marginRight: 5 }} >
              <HelpButton />
            </span>
            <button onClick={this.props.closeDialog} className='btn btn-primary' style={{ display: this.props.host === hosts.STANDALONE ? 'none' : 'inline-block' }}>Finish Editing</button>
          </div>
        </Header>
        <Body>
          {this.props.loading ?
            <div style={{ position: 'fixed', left: '50%', top: '50%' }}><Spinner size='xlarge' /></div> :
            <>
              <SplashScreen style={{ display: this.props.numberOfRules === 0 ? 'block' : 'none' }}>
                <i className='fas fa-info-circle' /> Click the blue plus button to add a Rule. Click <a href='help.html' target='_tulhelp'>here</a> for instructions.
              </SplashScreen>
              <Rules />
              <Questions />
              <ExportDialogue />
              <FeedbackDialogue />
              <Notes />
            </>
          }
        </Body>
      </div>
    </div>
  }
}

const mapStateToProps = function (store, ownProps) {
  let numberOfRules = 0
  let numberOfExamples = 0
  store.rules.forEach(row => {
    numberOfRules += row.length
    row.forEach(rule => {
      numberOfExamples += rule.examples.length
    })
  })

  return {
    infoMessage: getInfoText(numberOfRules, numberOfExamples),
    numberOfRules: numberOfRules,
    host: store.general.host,
    summary: store.general.summary,
    issueKey: store.general.issueKey,
    loading: store.general.loading
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    fetchExampleMap: () => dispatch(fetchExampleMapAsync()),
    clear: async () => {
      const shouldClear = await swal({
        title: 'Clear Example Map?',
        text: 'Click OK to clear this Example Map',
        icon: 'warning',
        buttons: true
      })
      if (shouldClear) {
        dispatch(clearExampleMap())
      }
    },
    openExportDialogue: () => dispatch(openExportDialogue()),
    closeDialog: async () => {
      await dispatch(saveExampleMap({ noDebounce: true }))
      await dispatch(closeEditor())
    },
    openFeedbackDialogue: () => dispatch(openFeedbackDialogue())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Editor)
